import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

import { AddressService } from '../../services/address.service';
import { StateService } from '../../services/state.service';
import { CountryService } from '../../services/country.service';
import { Globals } from '../../globals';

function notRequiredEmailValidator(control: FormControl) {
		if (!control.value) {
				return null;
		}

		return Validators.email(control);
}

@Component({
		selector: 'app-update-address',
		templateUrl: './update-address.component.html',
		styleUrls: ['./update-address.component.css', '../../app.component.css']
})

export class UpdateAddressComponent implements OnInit, OnDestroy {

	id: string;
	parent: string;
	customerOrSupplier: string;

	addressForm: FormGroup;
	address$: Observable<any>;

	addressSub: Subscription;

	countryId: any;
	stateId: any;

	countries: any[] = [];
	@Input() countryInit: string;
	@Output() countryModelChange = new EventEmitter();

	states: any[] = [];
	@Input() stateInit: string;
	@Output() stateModelChange = new EventEmitter();

	localitys: {name: string, value: string}[] = Object.keys(Globals.LOCALITYS).map(lockKey => ({name: `${lockKey}, ${Globals.LOCALITYS[lockKey].state}`, value: lockKey})).sort((a, b) => a.name > b.name ? 1 : -1);
	locality: string = '';

	municipilatys: {name: string, value: string}[] = Object.keys(Globals.MUNICIPALITYS).map(munKey => ({name: `${munKey}, ${Globals.MUNICIPALITYS[munKey].state}`, value: munKey})).sort((a,b) => a.name > b.name ? 1 : -1);
	municipality: string = '';

	requiresCartaPorte: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private addressService: AddressService,
		private countryService: CountryService,
		private stateService: StateService
		) {
			//window['log'] = () => console.log(this.customerOrSupplier, this.addressForm.valid);

		this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
		this.id = this.activatedRoute.snapshot.paramMap.get('id');
		this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];

		this.address$ = this.addressService.getAddress(this.id);
		this.addressSub = this.address$.subscribe(data => {
			const formData = {
				street: data.street,
				neighborhood: data.neighborhood,
				externalNumber: data.externalNumber,
				internalNumber: data.internalNumber,
				city: data.city,
				municipality: data.municipality,
				state: data.stateId,
				country: data.countryId,
				zipCode: data.zipCode,
				mobile: data.mobile,
				email: data.email,
				email2: data.email2,
				phone: data.phone,
				phone2: data.phone2
			};
			console.log(data);
			this.locality = data.xlocality || '';
			this.municipality = data.xmunicipality || '';
			this.requiresCartaPorte = data.requiresCartaPorte || false;
			this.addressForm = this.formBuilder.group(formData);
			this.loadCountriesAndStates();
		})
	}

	ngOnInit() {
		this.addressForm = this.formBuilder.group({
			street: ['', Validators.required],
			neighborhood: ['', Validators.required],
			externalNumber: ['', Validators.required],
			internalNumber: '',
			city: '',
			municipality: '',
			state: ['', Validators.required],
			country: ['', Validators.required],
			zipCode: ['', Validators.required],
			mobile: '',
			email: ['', notRequiredEmailValidator],
			email2: ['', notRequiredEmailValidator],
			phone: '',
			phone2: ''
		});
	}
	ngOnDestroy() {
		this.addressSub.unsubscribe();
	}

	onSubmitAddress({value, validate}: any) {
		value.stateId = value.state;
		value.countryId = value.country;
		delete value.country;
		delete value.state;
		value.xlocality = this.locality;
		value.xmunicipality = this.municipality;
		value.requiresCartaPorte = this.requiresCartaPorte;

		this.addressService.updateAddress(this.id, value);
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/addresses']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/addresses']);
		}
	}
		
	getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/addresses']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/addresses']);
		}
	}

	loadCountriesAndStates() {
		this.countries = Object.keys(Globals.COUNTRIES).map(key => ({id$: key, name: Globals.COUNTRIES[key].name}) );
		this.states = Object.keys(Globals.STATES).map(key => ({id$: key, name: Globals.STATES[key].name}) );
	}

	changeCountry(countryValue) {
		if(this.addressForm.get('country').value == countryValue) return;
		this.addressForm.get('country').setValue(countryValue);
	}

	changeState(stateValue) {
		if(this.addressForm.get('state').value == stateValue) return;
		this.addressForm.get('state').setValue(stateValue);
	}

}